var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSignupIcon = function SvgSignupIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4025_37448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.77143 10.0064C3.77143 7.52172 5.78066 5.5 8.25 5.5C10.7193 5.5 12.7286 7.52172 12.7286 10.0064C12.7286 12.4911 10.7193 14.5128 8.25 14.5128C5.78066 14.5128 3.77143 12.4911 3.77143 10.0064ZM11.0786 15.9359H5.42143C2.43257 15.9359 0 18.3836 0 21.391C0 22.8302 1.16254 24 2.59286 24H13.9071C15.3375 24 16.5 22.8302 16.5 21.391C16.5 18.3836 14.0674 15.9359 11.0786 15.9359Z",
    fill: "#144DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 0C17.0147 0 15 2.01472 15 4.5C15 6.98528 17.0147 9 19.5 9C21.9853 9 24 6.98528 24 4.5C24 2.01472 21.9853 0 19.5 0ZM19 2C19 1.72386 19.2239 1.5 19.5 1.5C19.7761 1.5 20 1.72386 20 2V4H22C22.2761 4 22.5 4.22386 22.5 4.5C22.5 4.77614 22.2761 5 22 5H20V7C20 7.27614 19.7761 7.5 19.5 7.5C19.2239 7.5 19 7.27614 19 7V5H17C16.7239 5 16.5 4.77614 16.5 4.5C16.5 4.22386 16.7239 4 17 4L19 4V2Z",
    fill: "#00B7FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4025_37448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSignupIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "signup-icon.3786a6a1d5f66233af4009b9db791616.svg";